import { builder } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

export const commonCreativeConfig = {
  url: builder.string('creative_url', {
    d:'',
    l:'',
    overrideType: 'imageWithRatio'
  }),
  creativeRatio: builder.number('creative_ratio', {
    l:'',
    description: `Ratio of the Asset<br>
Define if the creative orientation is portrait or landscape<br>
Mandatory for Thumbnail Ad delivery<br>
Default values are 1.78 for landscape and 0.56 for portrait for a 16:9 Asset<br>
Automatically computed from uploaded Assets<br>
Need to be manually defined for video programmatic, if not available in the video VAST or Adserver Redirect tags`,
    if: {
      valueOf: 'creative_url',
      is: 'any'
    },
    unit: units.aspectRatio
  })
};
